/* Coleção: gaveta de filtros, ordenação automática e «mostrar mais». */
class BsColecao extends HTMLElement {
  connectedCallback() {
    this.gaveta = this.querySelector('[data-bs-filtros]');
    const botao = this.querySelector('[data-bs-abrir-filtros]');
    botao?.addEventListener('click', () => this.alternar(true));
    this.querySelectorAll('[data-bs-fechar-filtros]').forEach((b) => b.addEventListener('click', () => this.alternar(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.gaveta?.classList.contains('is-aberta')) this.alternar(false); });

    this.querySelector('[data-bs-ordenar] select')?.addEventListener('change', (e) => e.target.form.submit());

    this.querySelector('[data-bs-mais]')?.addEventListener('click', (e) => this.mais(e));
  }

  alternar(abrir) {
    if (!this.gaveta) return;
    this.gaveta.classList.toggle('is-aberta', abrir);
    this.gaveta.setAttribute('aria-hidden', String(!abrir));
    this.querySelector('[data-bs-abrir-filtros]')?.setAttribute('aria-expanded', String(abrir));
    document.documentElement.style.overflow = abrir ? 'hidden' : '';
    if (abrir) window.BS?.lenis?.stop();
    else window.BS?.lenis?.start();
  }

  async mais(e) {
    e.preventDefault();
    const a = e.currentTarget;
    a.classList.add('is-carregando');
    try {
      const html = await (await fetch(a.href)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const novos = doc.querySelectorAll('[data-bs-grelha] > *');
      const grelha = this.querySelector('[data-bs-grelha]');
      novos.forEach((n) => grelha.appendChild(n));
      window.BS?.iniciar?.(grelha);
      const seguinte = doc.querySelector('[data-bs-mais]');
      if (seguinte) a.href = seguinte.href;
      else a.closest('.bs-colecao__mais')?.remove();
      window.history.replaceState({}, '', a.href);
    } catch (err) {
      window.location.href = a.href;
    } finally {
      a.classList.remove('is-carregando');
    }
  }
}

if (!customElements.get('bs-colecao')) customElements.define('bs-colecao', BsColecao);
